export const checkEmail = (email) => {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(String(email)?.toLowerCase());
};

export const isStrongPassword = (str) => {
	const format = new RegExp("^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])(?=.*[@!#$%^&+=])(?=.{8,})");
	return format.test(str);
};

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();

export const capitalizeAllWords = (str) => {
	if (!str) {
		return "";
	}
	return str
		.toLowerCase()
		.split(/([\s'-]+)/)
		.map((part) => {
			if (part && ![" ", "-", "'"].includes(part)) {
				return part.charAt(0).toUpperCase() + part.slice(1);
			}
			return part;
		})
		.join("");
};

export const removeUnderscore = (str) => str.replace(/_/g, " ");

export const alphaSort = (str1, str2) => str1.localeCompare(str2);

export const toInitials = (firstName, lastName) => {
	if (lastName && firstName) {
		return `${firstName[0]}${lastName[0]}`;
	}
	if (lastName) {
		return lastName[0];
	}
	if (firstName) {
		return firstName[0];
	}
	return "";
};

export const toInitialsUserName = (userName) => {
	if (!userName || typeof userName !== "string") {
		return "";
	}
	return userName
		.split(" ")
		.map((word) => word[0])
		.join("");
};

export const compareInsensitiveCaseString = (str1, str2) => {
	if (!str1 || !str2) {
		return false;
	}
	return str1.toLowerCase() === str2.toLowerCase();
};

export const removeTags = (str) => str?.replace(/<\/?[^>]+(>|$)/g, "");

export const stringToColor = (str) => {
	if (!str) {
		return "#1976d2";
	}

	let hash = 0;
	for (let i = 0; i < str.length; i += 1) {
		// eslint-disable-next-line no-bitwise
		hash = str.charCodeAt(i) + ((hash << 5) - hash);
	}

	// Generate pleasant colors (avoiding too dark or too light)
	const colors = [
		"#1976d2", // Blue
		"#388e3c", // Green
		"#d32f2f", // Red
		"#7b1fa2", // Purple
		"#f57c00", // Orange
		"#0288d1", // Light Blue
		"#c2185b", // Pink
		"#5d4037", // Brown
		"#455a64", // Blue Grey
		"#00796b", // Teal
		"#fbc02d", // Yellow
		"#303f9f", // Indigo
	];

	const index = Math.abs(hash) % colors.length;
	return colors[index];
};

export const getAvatarColor = (name) => {
	const bgcolor = stringToColor(name);
	return {
		bgcolor,
		color: "#fff",
	};
};

export function toCamelCase(str) {
	if (typeof str !== "string" || str.length === 0) {
		return str;
	}
	const normalizedStr = str.replace(/[_\-\s]+/g, " ");
	const words = normalizedStr.split(" ");
	const camelCaseWords = words.map((word, index) => {
		if (word.length === 0) {
			return "";
		}
		if (index === 0) {
			return word.charAt(0).toLowerCase() + word.slice(1);
		}
		return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
	});
	return camelCaseWords.join("");
}
